var WDPRO = window.WDPRO = window.WDPRO || {};
WDPRO.Personalization = WDPRO.Personalization || {};
WDPRO.Personalization.version = '%%VERSION%%';
